import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import { MsalProvider } from "@azure/msal-react";
import msalInstance from "./msalInstance"

// Keep account state in sync across tabs/windows
msalInstance.enableAccountStorageEvents();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

//get the current URL to know whether internal or external access
const candidateHostName = 'aspire-candidate.burnsmcd.com';
const isCandidateHost = window.location.hostname === candidateHostName;

const allowedCandidateReferrers = [
    'https://careers.burnsmcd.com/welcome-to-employee-ownership',
    'https://info.burnsmcd.com/welcome-to-employee-ownership-us'
];

function fromAllowedCandidateReferrer() {
    const ref = document.referrer || '';
    return allowedCandidateReferrers.some((u) => ref.startsWith(u));
}

if (isCandidateHost) {
    if (fromAllowedCandidateReferrer()) {
        root.render(
            <Router>
                <App audience="External" />
            </Router>
        );
    } else {
        root.render(
            <Router>
                <App audience="Unauthorized" />
            </Router>
        );
    }
} else {
    (async () => {
        root.render(
            <Router>
                <MsalProvider instance={msalInstance}>
                    <App audience="Internal" />
                </MsalProvider>
            </Router>
        );
    })();
}
